export enum FORM_ERROR_MESSAGES {
  REQUIRED = "This field is required",
  LONG = "is too long",
  SHORT = "is too short",
  PASSWORDS_MATCH = "Passwords do not match",
  NUMBER = "must be a number",
  EMAIL = "Please enter a valid email",
  UPPERCASE = "At least 1 uppercase letter",
  LOWERCASE = "At least 1 lowercase letter",
  DIGIT = "At least 1 digit",
  ONLY_TEXT = "must be without numbers",
}
